import Styles from './Home.module.scss'

import { ChevronRight } from 'blaze-ui/icons/24'
import { Calendar2 } from 'blaze-ui/icons'
import { Button } from 'blaze-ui/Button'
import { Text } from 'blaze-ui/Text/Text'
import {
  cadenceToDisplay,
  DayAndTime,
  firstAvailableTime,
  isToday,
  timeOfDayToDisplay,
  TimeOfDay,
} from '../../StartDateAndPostFrequencyModal'
import dayjs, { Dayjs } from 'dayjs'
import { PostingCadence } from '../../../../ScheduleContent'
import { MenuTrigger } from 'components/MenuTrigger/MenuTrigger'
import { Calendar } from 'components/Calendar/Calendar'
import { Drawer } from 'components/Drawer'

interface Props {
  startDate: Dayjs
  setStartDate: (newStartDate: Dayjs) => void
  postingCadence: PostingCadence
  timeOfDay: TimeOfDay
  setTimeOfDay: (timeOfDay: TimeOfDay) => void
  days: DayAndTime[]
  setDays: (days: DayAndTime[]) => void
  customTime: string | undefined
  customAmOrPm: string
  setCustomAmOrPm: (amOrPm: string) => void
  send: (page: string) => void
  onConfirm: () => void
}

export const Home = ({
  startDate,
  setStartDate,
  postingCadence,
  send,
  timeOfDay,
  setTimeOfDay,
  days,
  setDays,
  customTime,
  customAmOrPm,
  setCustomAmOrPm,
  onConfirm,
}: Props) => {
  return (
    <>
      <Drawer.Container>
        <div className={Styles.container}>
          <div className={Styles.startDateContainer}>
            <Text variant="placeholder" color="var(--dark-80)">
              Start posting on
            </Text>
            <MenuTrigger placement="bottom-start">
              <Button
                size="lg"
                variant="secondary"
                frontIcon={Calendar2}
                endIcon={ChevronRight}
                justifyContent="flex-start"
              >
                {startDate.format('ddd, MMM D YYYY')}
              </Button>
              <div>
                <Calendar
                  minValue={dayjs().format('YYYY-MM-DD')}
                  value={startDate.format('YYYY-MM-DD')}
                  onChange={(value) => {
                    const newStartDate = dayjs(value).minute(0)

                    if (isToday(newStartDate)) {
                      newStartDate.hour(dayjs().hour()).minute(dayjs().minute())
                      if (days.find((d) => d.day === newStartDate.day())) {
                        setTimeOfDay(firstAvailableTime(dayjs().hour()))
                      }
                      if (dayjs().hour() > 11) {
                        setCustomAmOrPm('pm')
                      }

                      let newDaysAndTimes = []
                      if (postingCadence === PostingCadence.Once) {
                        newDaysAndTimes = days.map((day) => {
                          return {
                            ...day,
                            day: newStartDate.day(),
                            time: { ...day.time, ofDay: firstAvailableTime(dayjs().hour()) },
                          }
                        })
                      } else {
                        newDaysAndTimes = days.map((day) => {
                          if (day.day === dayjs().day()) {
                            const ofDay = firstAvailableTime(dayjs().hour())
                            return { ...day, time: { ofDay } }
                          }

                          return day
                        })
                      }
                      setDays(newDaysAndTimes)
                    } else if (postingCadence === PostingCadence.Once) {
                      const newDaysAndTimes = days.map((day) => {
                        return { ...day, day: newStartDate.day() }
                      })
                      setDays(newDaysAndTimes)
                    }
                    setStartDate(newStartDate)
                  }}
                />
              </div>
            </MenuTrigger>
          </div>
          <div className={Styles.postFrequencyContainer}>
            <Text variant="placeholder" color="var(--dark-80)">
              How often do you want to post?
            </Text>
            <Button
              size="lg"
              variant="secondary"
              endIcon={ChevronRight}
              justifyContent="flex-start"
              onPress={() => send('CHOOSE_FREQUENCY')}
            >
              <div className={Styles.postingCadenceContainer}>
                <span>{cadenceToDisplay(postingCadence, startDate).text}</span>
                <span className={Styles.cadenceDays}>{cadenceToDisplay(postingCadence, startDate).days}</span>
              </div>
            </Button>
          </div>
          <div className={Styles.timeOfDayContainer}>
            <Text variant="placeholder" color="var(--dark-80)">
              Choose your time of day
            </Text>
            <Button
              size="lg"
              variant="secondary"
              endIcon={ChevronRight}
              justifyContent="flex-start"
              onPress={() => send('CHOOSE_TIME_OF_DAY')}
            >
              <div className={Styles.timeOfDayTextContainer}>
                {timeOfDay === TimeOfDay.Custom ? (
                  <>
                    {customTime && customAmOrPm ? (
                      <span>Let me choose time</span>
                    ) : (
                      <span>{timeOfDayToDisplay(timeOfDay).text}</span>
                    )}
                    <span>
                      {customTime}
                      {customAmOrPm}
                    </span>
                  </>
                ) : (
                  <>
                    <span>{timeOfDayToDisplay(timeOfDay).text}</span>
                    <span className={Styles.cadenceDays}>{timeOfDayToDisplay(timeOfDay).time}</span>
                  </>
                )}
              </div>
            </Button>
          </div>
          <Button size="lg" onPress={onConfirm}>
            Confirm
          </Button>
        </div>
      </Drawer.Container>
    </>
  )
}
